import React from 'react'
import { Input, InputProps } from 'antd'

type Props = Omit<InputProps, 'onChange' | 'value'> & {
  value?: string
  onChange?: (value: string) => void
  allowNegative?: boolean
}

/**
 * Числовой инпут, принимающий и точку и запятую как десятичный разделитель.
 * Хранит значение как строку — парсится через parseDecimal при сабмите.
 * Фильтрует ввод на лету: только цифры, точка, запятая, опционально минус.
 */
export const NumericInput: React.FC<Props> = ({
  value,
  onChange,
  allowNegative = true,
  ...rest
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const next = e.target.value
    if (next === '') {
      onChange?.('')
      return
    }
    const pattern = allowNegative ? /^-?[\d.,]*$/ : /^[\d.,]*$/
    if (pattern.test(next)) {
      onChange?.(next)
    }
  }

  return (
    <Input
      {...rest}
      value={value ?? ''}
      onChange={handleChange}
      inputMode="decimal"
    />
  )
}
